import { PayoutController } from "apps/oneOnboarding/pricing/payout/PayoutController";
import type { PayoutItem } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";

export const BatchPayoutController: FunctionComponent = () => {
    const { control, setValue } = useFormContext<BulkPropertyFormData>();
    const propertyDataList = useWatch<BulkPropertyFormData>({
        control,
        name: "propertyDataList",
    }) as BulkPropertyFormData["propertyDataList"];

    const handleSetPayoutItem = (value: PayoutItem | null) => {
        propertyDataList.forEach((_, index) => {
            if (index === 0) return;
            setValue(`propertyDataList.${index}.payout`, value as PayoutItem | null);
        });
    };

    return <PayoutController fieldPrefix="propertyDataList.0" onSetValue={handleSetPayoutItem} />;
};
